import { useContext } from "react";

import AllUserListContext from "../context/AllUserListProvider";

const useAllUserList = () => {
  return useContext(AllUserListContext);
}

export default useAllUserList;